export const tasksToMarker = (tasks, selectedTaskId = false) => {
  const tasksToMap = Array.isArray(tasks)? tasks : [tasks];

  let markers = tasks ? tasksToMap.map((task, i) => {
    let color = "#1e88e5";
    if (selectedTaskId === task.id) color =  "#ce4c00";
    if (task.assignedToCurrentUser) color =  "#006e33";
    let lat = '';
    let lon = '';
    if(
      task?.locationDuringAssignment?.xCoordinate &&
      task?.locationDuringAssignment?.xCoordinate !== ""
    ) {
      lat = task.locationDuringAssignment.xCoordinate;
      lon = task.locationDuringAssignment.yCoordinate;
    }
    const coordinate = {
        lat,
        lon,
    }
    return ({
      data: { ...task, datatype: "task"},
      icon: 'pin',
      coordinate,
      color,
      size: "45px",
    })
  }) : [{}];

  return markers;
}
